import React, { useState, useEffect } from "react";
import { Prompt, Link } from "react-router-dom";
import { connect } from "react-redux";
import { updateSettings } from "redux/settings/settings.actions";
import { setRequestError } from "redux/system/system.actions";
import {
    Icon,
    Button,
    Divider,
    message,
    Switch,
    Card,
    Typography,
    Select,
    Tag,
} from "antd";

import http from "services/httpService";
import { apiUrl } from "config.json";

const AppointmentList = ({
    AList,
    clinicID,
    updateSettings,
    setRequestError,
}) => {
    const [appointmentList, setAppointmentList] = useState(AList);
    const [isAListEdited, setIsAListEdited] = useState(false);

    const { Title } = Typography;
    const { Option } = Select;

    useEffect(() => {
        window.addEventListener("beforeunload", beforeunload);
        return () => {
            window.removeEventListener("beforeunload", beforeunload);
        };
    }, [isAListEdited]);

    function beforeunload(e) {
        if (isAListEdited) {
            e.preventDefault();
            e.returnValue = true;
        }
    }

    const handleSwitchChange = (name, checked) => {
        setAppointmentList({
            ...appointmentList,
            [name]: checked ? true : false,
        });
        setIsAListEdited(true);
    };

    const handleSelectChange = (name, value) => {
        setAppointmentList({
            ...appointmentList,
            [name]: value,
        });
        setIsAListEdited(true);
    };

    const handleAppointmentListSave = async () => {
        try {
            updateSettings({ appointmentList });
            setIsAListEdited(false);
            message.success("Case list settings successfully saved!");
            const AList = JSON.stringify(appointmentList);
            await http.put(`${apiUrl}/settings/${clinicID}`, {
                appointment_list: AList,
            });
        } catch (error) {
            setRequestError({
                errorMessage: "Something went wrong on our last :(",
                errorSubMessage: error.message,
            });
        }
    };

    return (
        <Card>
            <div style={{ marginBottom: 10 }}>
                <Link to="/settings">
                    <Icon type="arrow-left" /> Back to Settings Menu
                </Link>
            </div>

            <Divider />
            <Title level={4}>Appointment Information</Title>
            <table cellPadding={5}>
                <tbody>
                    <tr>
                        <td style={{ width: 200 }}>Show Patient Image:</td>
                        <td>
                            <Switch
                                checked={appointmentList.isShowImage}
                                onChange={(checked) =>
                                    handleSwitchChange("isShowImage", checked)
                                }
                            />
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: 200 }}>Show Details:</td>
                        <td>
                            <Switch
                                checked={appointmentList.isShowDetails}
                                onChange={(checked) =>
                                    handleSwitchChange("isShowDetails", checked)
                                }
                            />
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: 200 }}>Show Assigned Doctor:</td>
                        <td>
                            <Switch
                                checked={appointmentList.isShowDoctor}
                                onChange={(checked) =>
                                    handleSwitchChange("isShowDoctor", checked)
                                }
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
            <Divider />
            <Title level={4}>Status Color</Title>
            <table cellPadding={5}>
                <tbody>
                    <tr>
                        <td style={{ width: 200 }}>Pending:</td>
                        <td>
                            <Select
                                value={appointmentList.pendingStatusColor}
                                style={{ width: 150 }}
                                onChange={(value) =>
                                    handleSelectChange(
                                        "pendingStatusColor",
                                        value
                                    )
                                }
                            >
                                <Option value="magenta">
                                    <Tag color="magenta">Magenta</Tag>
                                </Option>
                                <Option value="red">
                                    <Tag color="red">Red</Tag>
                                </Option>
                                <Option value="volcano">
                                    <Tag color="volcano">Volcano</Tag>
                                </Option>
                                <Option value="orange">
                                    <Tag color="orange">Orange</Tag>
                                </Option>
                                <Option value="gold">
                                    <Tag color="gold">Gold</Tag>
                                </Option>
                                <Option value="lime">
                                    <Tag color="lime">Lime</Tag>
                                </Option>
                                <Option value="green">
                                    <Tag color="green">Green</Tag>
                                </Option>
                                <Option value="cyan">
                                    <Tag color="cyan">Cyan</Tag>
                                </Option>
                                <Option value="blue">
                                    <Tag color="blue">Blue</Tag>
                                </Option>
                                <Option value="geekblue">
                                    <Tag color="geekblue">Geek Blue</Tag>
                                </Option>
                                <Option value="purple">
                                    <Tag color="purple">Purple</Tag>
                                </Option>
                                <Option value="">
                                    <Tag>Grey</Tag>
                                </Option>
                            </Select>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: 200 }}>Confirmed:</td>
                        <td>
                            <Select
                                value={appointmentList.confirmedStatusColor}
                                style={{ width: 150 }}
                                onChange={(value) =>
                                    handleSelectChange(
                                        "confirmedStatusColor",
                                        value
                                    )
                                }
                            >
                                <Option value="magenta">
                                    <Tag color="magenta">Magenta</Tag>
                                </Option>
                                <Option value="red">
                                    <Tag color="red">Red</Tag>
                                </Option>
                                <Option value="volcano">
                                    <Tag color="volcano">Volcano</Tag>
                                </Option>
                                <Option value="orange">
                                    <Tag color="orange">Orange</Tag>
                                </Option>
                                <Option value="gold">
                                    <Tag color="gold">Gold</Tag>
                                </Option>
                                <Option value="lime">
                                    <Tag color="lime">Lime</Tag>
                                </Option>
                                <Option value="green">
                                    <Tag color="green">Green</Tag>
                                </Option>
                                <Option value="cyan">
                                    <Tag color="cyan">Cyan</Tag>
                                </Option>
                                <Option value="blue">
                                    <Tag color="blue">Blue</Tag>
                                </Option>
                                <Option value="geekblue">
                                    <Tag color="geekblue">Geek Blue</Tag>
                                </Option>
                                <Option value="purple">
                                    <Tag color="purple">Purple</Tag>
                                </Option>
                                <Option value="">
                                    <Tag>Grey</Tag>
                                </Option>
                            </Select>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: 200 }}>Canceled:</td>
                        <td>
                            <Select
                                value={appointmentList.canceledStatusColor}
                                style={{ width: 150 }}
                                onChange={(value) =>
                                    handleSelectChange(
                                        "canceledStatusColor",
                                        value
                                    )
                                }
                            >
                                <Option value="magenta">
                                    <Tag color="magenta">Magenta</Tag>
                                </Option>
                                <Option value="red">
                                    <Tag color="red">Red</Tag>
                                </Option>
                                <Option value="volcano">
                                    <Tag color="volcano">Volcano</Tag>
                                </Option>
                                <Option value="orange">
                                    <Tag color="orange">Orange</Tag>
                                </Option>
                                <Option value="gold">
                                    <Tag color="gold">Gold</Tag>
                                </Option>
                                <Option value="lime">
                                    <Tag color="lime">Lime</Tag>
                                </Option>
                                <Option value="green">
                                    <Tag color="green">Green</Tag>
                                </Option>
                                <Option value="cyan">
                                    <Tag color="cyan">Cyan</Tag>
                                </Option>
                                <Option value="blue">
                                    <Tag color="blue">Blue</Tag>
                                </Option>
                                <Option value="geekblue">
                                    <Tag color="geekblue">Geek Blue</Tag>
                                </Option>
                                <Option value="purple">
                                    <Tag color="purple">Purple</Tag>
                                </Option>
                                <Option value="">
                                    <Tag>Grey</Tag>
                                </Option>
                            </Select>
                        </td>
                    </tr>
                </tbody>
            </table>
            <Divider />

            <Button
                type="primary"
                size="large"
                onClick={handleAppointmentListSave}
            >
                Save Case List Settings
            </Button>

            <Prompt
                when={isAListEdited}
                message="Changes you made may not be saved. Are you sure you want to leave?"
            />
        </Card>
    );
};

const mapStateToProps = (state) => ({
    AList: state.Settings.appointmentList,
    clinicID: state.UserDetails.clinicDetails.clinic_id,
});

const mapDispatchToProps = (dispatch) => ({
    updateSettings: (updatedSettings) =>
        dispatch(updateSettings(updatedSettings)),
    setRequestError: (data) => dispatch(setRequestError(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentList);
